import {
  Text,
  Title,
  Button,
  Badge,
} from "@mantine/core";
import image from "../public/mobile_calendar_cut.webp";
import { MediaStage } from "./MediaStage";
import classes from "../styles/MainSection.module.css";
import { IconCheck, IconRocket, IconStar, IconClock } from "@tabler/icons";

export function MainSection() {
  const features = [
    { text: "דף עסקי: כרטיס הביקור הדיגיטלי החדש שלך", icon: <IconStar size={16} /> },
    { text: "זימון תורים 24/7: העסק עובד גם כשאתם נחים", icon: <IconClock size={16} /> },
    { text: "אוטומציה מלאה: תזכורות, אישורים וניהול לקוחות", icon: <IconRocket size={16} /> },
    { text: "גישה מכל מקום: שליטה מלאה מהנייד ומהמחשב", icon: <IconCheck size={16} /> },
  ];

  return (
    <div className={classes.wrapper}>
      <div className={classes.image}>
        <MediaStage
          image={image}
          variant="phone"
          callouts={["זימון תורים 24/7", "תזכורות אוטומטיות"]}
          alt="יומן התורים השבועי של QuickTor בטלפון, עם תורים צבעוניים לפי טיפול וכפתור הוספת תור חדש"
        />
      </div>
      <div className={classes.body}>
        <Badge
          size="lg"
          variant="gradient"
          gradient={{ from: 'blue', to: 'cyan' }}
          className={classes.badge}
        >
          בדרך להצלחה
        </Badge>

        <Title className={classes.title} order={2}>
          הפכו את העסק שלכם למכונה של תורים
        </Title>
        <Text className={classes.subtitle}>
          יותר מלקוחות מרוצים. יותר הכנסות. פחות כאב ראש.
          המערכת שתעשה לכם סדר ביומן ותשאיר אתכם בפוקוס על מה שחשוב באמת.
        </Text>

        <div className={classes.featureList}>
          {features.map((feature, index) => (
            <div key={index} className={classes.featureItem}>
              <div className={classes.checkIconWrapper}>
                {feature.icon}
              </div>
              <Text className={classes.featureText}>
                {feature.text}
              </Text>
            </div>
          ))}
        </div>

        <Button
          className={classes.ctaButton}
          component="a"
          href={"https://app.quicktor.co.il"}
          rightSection={
            <IconRocket size={20} stroke={2} style={{ marginLeft: 8 }} />
          }
        >
          אני רוצה להתחיל לקבל תורים &gt;&gt;
        </Button>
      </div>
    </div>
  );
}
